import { render, staticRenderFns } from "./EcashKits.vue?vue&type=template&id=a11835b8&"
import script from "./EcashKits.vue?vue&type=script&lang=js&"
export * from "./EcashKits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports